import { FaInstagram, FaLinkedin } from "react-icons/fa";
import { FiArrowUpRight, FiMail } from "react-icons/fi";

export default function Contact() {
  return (
    <main className="premium-page">
      <section className="premium-shell flex min-h-[72vh] flex-col items-center gap-10">
        <div className="page-hero-block">
          <p className="eyebrow">Start a build</p>
          <h1 className="hero-heading mt-5">
            Bring Code7s into your next product.
          </h1>
          <p className="hero-copy">
            Tell us what you are building: a startup MVP, mobile app, premium
            website, SaaS platform, ecommerce product, dashboard, internal tool
            or digital product you want to launch with a serious roadmap.
          </p>

          <a
            href="mailto:code7s.official@gmail.com"
            className="mt-9 inline-flex items-center gap-3 rounded-full bg-neutral-950 px-6 py-3.5 text-sm font-bold text-white shadow-[0_18px_50px_rgba(17,17,17,0.2)] transition hover:-translate-y-0.5 hover:bg-neutral-800"
          >
            <FiMail aria-hidden="true" />
            code7s.official@gmail.com
          </a>

          <div className="mt-8 flex items-center justify-center gap-4 text-neutral-700">
            <a href="https://www.instagram.com/code7s/" aria-label="Code7s on Instagram" className="grid h-11 w-11 place-items-center rounded-full border border-neutral-950/10 bg-white/70 text-xl transition hover:bg-white">
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/code7s/about/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Code7s on LinkedIn"
              className="grid h-11 w-11 place-items-center rounded-full border border-neutral-950/10 bg-white/70 text-xl transition hover:bg-white"
            >
              <FaLinkedin />
            </a>
          </div>
        </div>

        <form className="premium-card w-full max-w-3xl rounded-[30px] p-5 md:p-8">
          <div className="grid gap-5 md:grid-cols-2">
            <label className="block">
              <span className="text-sm font-bold text-neutral-600">First name</span>
              <input className="mt-2 w-full rounded-2xl border border-neutral-950/10 bg-white/75 px-4 py-3 outline-none transition focus:border-neutral-950/40" type="text" />
            </label>
            <label className="block">
              <span className="text-sm font-bold text-neutral-600">Last name</span>
              <input className="mt-2 w-full rounded-2xl border border-neutral-950/10 bg-white/75 px-4 py-3 outline-none transition focus:border-neutral-950/40" type="text" />
            </label>
          </div>

          <label className="mt-5 block">
            <span className="text-sm font-bold text-neutral-600">Email</span>
            <input className="mt-2 w-full rounded-2xl border border-neutral-950/10 bg-white/75 px-4 py-3 outline-none transition focus:border-neutral-950/40" type="email" />
          </label>

          <label className="mt-5 block">
            <span className="text-sm font-bold text-neutral-600">Project type</span>
            <select className="mt-2 w-full rounded-2xl border border-neutral-950/10 bg-white/75 px-4 py-3 outline-none transition focus:border-neutral-950/40">
              <option>Startup MVP</option>
              <option>Mobile app</option>
              <option>Website or landing page</option>
              <option>SaaS platform</option>
              <option>Product design</option>
            </select>
          </label>

          <label className="mt-5 block">
            <span className="text-sm font-bold text-neutral-600">What are you building?</span>
            <textarea className="mt-2 min-h-36 w-full resize-none rounded-2xl border border-neutral-950/10 bg-white/75 px-4 py-3 outline-none transition focus:border-neutral-950/40" />
          </label>

          <button
            type="submit"
            className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-neutral-950 px-6 py-3.5 text-sm font-bold text-white transition hover:bg-neutral-800"
          >
            Submit inquiry
            <FiArrowUpRight aria-hidden="true" />
          </button>
        </form>
      </section>
    </main>
  );
}
